import "../../auto-mapper/AutoMapperProvider.js";
import { useAutoMapper } from "../../auto-mapper/hooks.js";
import "typesafe-actions";
import "rxjs";
import "rxjs/operators";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "redux-observable";
import "../../api/types.js";
import "immer";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../../redux-folder/async-action/action.js";
import "../../redux-folder/error-handling/action.js";
import "../../redux-folder/actions.js";
import "fast-deep-equal/es6";
import "redux";
import "../../redux-folder/entity/epics.js";
import "normalizr";
import "../../redux-folder/entity/EntityProvider.js";
import "../../redux-folder/realtime/RealtimeNotification.js";
import "reselect";
import { useViewInit } from "../../redux-folder/view/hooks.js";
import { getNonEmptyValueValidator } from "../../redux-folder/view/utils.js";
import { UserActivitySummaryViewModelKeysTypeName, UserActivitySummaryQueryFieldsTypeName } from "./constants.js";
import { UserActivitySummaryServiceModel } from "./service.js";
import { UserActivitySummaryViewModel } from "./types.js";
function useUserActivitySummary({
  id,
  fields,
  viewType,
  displayName,
  defaultFilters,
  validateFilter,
  cleanDelay,
  userActivitySummaryEntity
}) {
  const mapper = useAutoMapper();
  const {
    items,
    searchFilter,
    viewEntity: { filter: filterString },
    handleFilterChange
  } = useViewInit({
    viewType,
    entity: {
      entity: userActivitySummaryEntity,
      fields: mapFields(fields)
    },
    defaultFilters: getDefaultFilters(),
    defaultPaging: { page: 1, pageSize: 1 },
    validateFilter: validateFilter ?? getNonEmptyValueValidator("uid"),
    displayName,
    cleanDelay
  });
  const item = mapper.tryMap(items?.[0], UserActivitySummaryServiceModel, UserActivitySummaryViewModel);
  return {
    item: item?.model,
    searchFilter,
    filterString,
    handleFilterChange
  };
  function getDefaultFilters() {
    const filters = [...defaultFilters ?? []];
    if (id) {
      filters.push({ key: "uid", value: id });
    }
    return filters;
  }
  function mapField(field) {
    return mapper.map(
      field,
      UserActivitySummaryViewModelKeysTypeName,
      UserActivitySummaryQueryFieldsTypeName
    );
  }
  function mapFields(fields2) {
    return fields2?.map(mapField);
  }
}
export {
  useUserActivitySummary
};
//# sourceMappingURL=hooks.js.map
